module.exports = __webpack_public_path__ + "images/sort_bullet.gif";